import {Statistic, Tooltip} from 'antd';
import {AccountStats} from 'api/generated';
import {HintIcon, Stack} from 'components';
import {formatAmount} from 'lib/formaters';
import moment from 'moment/moment';
import React from 'react';
import styled from 'styled-components';

type Props = {
  stats: AccountStats['stats'] | null | undefined;
};

const Container = styled(Stack)`
  flex-shrink: 0;
  margin-left: 10px;
`;

export const StatsSummary: React.FC<Props> = ({stats}) => {
  if (!stats) return null;
  const avgMonthlyVolume = formatAmount(stats.avgMonthlyVolume, 'EUR', 0) || '';
  const duration = moment.duration(stats.activeMonths || 1, 'month').humanize();
  return (
    <Tooltip
      placement="left"
      title={`${avgMonthlyVolume} total gross volume per month on average, active ${duration} `}>
      <Container>
        <Statistic
          value={avgMonthlyVolume}
          suffix={<span style={{fontSize: '60%'}}>/ month, {duration}</span>}
        />
        <HintIcon />
      </Container>
    </Tooltip>
  );
};
